var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 0,
    gradientUnits: "userSpaceOnUse",
    x1: 42.604,
    y1: 36.846,
    x2: 42.15,
    y2: -10.476
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4da70e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ded46"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99999 0 0 .99999-18.471 10.822)",
    enableBackground: "new"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 24,
    cy: 13.185,
    cx: 42.473,
    fill: "url(#0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.563 18.201l-1.205 4.339c-.014.052-.045.098-.085.132l-3.704 3.086c-.048.04-.107.061-.168.061-.027 0-.051-.004-.077-.012-.085-.026-.151-.093-.176-.178l-1.272-4.381c-.927.037-1.745-.175-2.418-.639l-1.686 1.388c-.107.088-.263.079-.358-.022l-1.252-1.32c-.048-.051-.074-.12-.072-.191 0-.071.033-.138.085-.185l1.669-1.534c-.142-.39-.398-1.36-.127-2.837l-4.289-1.569c-.083-.03-.146-.101-.166-.188-.021-.087 0-.177.066-.242l3.321-3.497c.039-.041.089-.068.144-.078l4.375-.784c.823-.954 1.781-1.919 2.848-2.87 6.142-5.477 10.944-6.294 13.259-6.294.762 0 1.182.093 1.2.096.104.023.184.108.202.213.046.272 1.046 6.765-7.387 15.215-.011.011-1.141 1.109-2.727 2.29m-.399-4.723c1.467 0 2.656-1.192 2.656-2.662 0-1.47-1.189-2.662-2.656-2.662-1.467 0-2.656 1.192-2.656 2.662 0 1.47 1.189 2.662 2.656 2.662m-9.998 9.522c.057-.056.14-.079.218-.059.078.019.141.077.166.153l.604 1.798c.029.086.001.181-.06.244l-2.865 2.744c-.044.042-.101.065-.162.065h-2.415c-.095 0-.181-.058-.217-.146-.035-.088-.014-.19.054-.256l4.677-4.542m-3.2-1.466c.045-.046.106-.144.169-.144h.001c.066 0 .128.102.171.152l1.039 1.275c.08.092.075.23-.001.317l-4.629 4.741c-.044.045-.104.07-.167.07h-.765-.234c-.129 0-.234-.105-.234-.234v-1.121c0-.06.024-.154.064-.197l4.59-4.859zm-4.584.577l3.345-3.267c.078-.076.198-.088.288-.03l1.37.869c.061.038.099.102.107.172.001.071-.017.141-.068.191l-4.714 4.686c-.045.044-.105.068-.165.068-.03 0-.061-.006-.09-.018-.086-.036-.143-.121-.143-.216v-2.288c0-.063.026-.124.07-.167z",
    fill: "#fff",
    fillOpacity: 0.852
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.14b2d142.svg";
export { ForwardRef as ReactComponent };